/**
 * Skeleton — v2 상태 화면 S1 (목록 로딩). shimmer 1.4s, 스피너 금지.
 * docs/design-v2/부냥 상태 변형 v2.html `.sk` / `.lcard` 스켈레톤.
 */

import React from 'react';

export const SkeletonBlock: React.FC<{ className?: string; style?: React.CSSProperties }> = ({
  className = '',
  style,
}) => <span aria-hidden className={`v2-sk block ${className}`} style={style} />;

/** 목록 카드(.lcard) 스켈레톤 1개 */
export const ListCardSkeleton: React.FC = () => (
  <div className="flex gap-3 rounded-ca-3xl bg-frame p-3 shadow-ca-card" data-testid="list-card-skeleton">
    <SkeletonBlock className="h-[88px] w-[104px] shrink-0 !rounded-ca-xl" />
    <div className="flex flex-1 flex-col gap-1.5">
      <SkeletonBlock className="h-4 w-[70px] !rounded-full" />
      <SkeletonBlock className="h-[17px] w-4/5" />
      <SkeletonBlock className="h-3.5 w-3/5" />
      <SkeletonBlock className="h-[18px] w-[45%]" />
    </div>
  </div>
);

/** 목록 로딩 — 스켈레톤 N개 (기본 5) */
export const ListSkeleton: React.FC<{ count?: number; className?: string }> = ({ count = 5, className = '' }) => (
  <div role="status" aria-live="polite" aria-label="불러오는 중" className={className}>
    <span className="sr-only">분양 정보를 불러오는 중</span>
    {Array.from({ length: count }).map((_, i) => (
      <ListCardSkeleton key={i} />
    ))}
  </div>
);

/** 상세 로딩 — 히어로 + 제목 + 스펙바 + 섹션 카드 */
export const DetailSkeleton: React.FC = () => (
  <div role="status" aria-live="polite" aria-label="불러오는 중" className="flex flex-col gap-3 pb-6">
    <span className="sr-only">분양 정보를 불러오는 중</span>
    <SkeletonBlock className="h-[250px] w-full !rounded-none lg:h-[420px]" />
    <div className="flex flex-col gap-2 px-4">
      <SkeletonBlock className="h-4 w-24" />
      <SkeletonBlock className="h-7 w-3/4" />
      <SkeletonBlock className="h-4 w-1/2" />
    </div>
    <div className="px-4">
      <SkeletonBlock className="h-[76px] w-full !rounded-ca-3xl" />
    </div>
    {[0, 1].map((i) => (
      <div key={i} className="px-4">
        <SkeletonBlock className="h-[160px] w-full !rounded-ca-3xl" />
      </div>
    ))}
  </div>
);

export default ListSkeleton;
